// axiosSetup.js
import axios from "axios";
import { handleUnauthorized } from "./authHandler";

let interceptorsAttached = false;

export const setupAxiosInterceptors = () => {
  // Avoid registering the same interceptor multiple times (e.g. React Strict Mode).
  if (interceptorsAttached) return;
  interceptorsAttached = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const originalRequest = error.config;

      // Don't handle 401 errors here if:
      // 1. The request is being retried (refresh logic is handling it)
      // 2. The request is to the refresh token endpoint
      // 3. The request is to the login endpoint
      const isRetry = originalRequest?._retry;
      const isRefreshRequest =
        originalRequest?.url?.includes("/auth/refreshToken") ||
        originalRequest?.url?.includes("/auth/refresh");
      const isLoginRequest = originalRequest?.url?.includes("/api/v1/auth/logIn");

      // Only call handleUnauthorized if it's not a retry and not a refresh/login request
      // This allows the refresh logic in axiosProtected.js and axios.js to handle 401s first
      if (
        error.response?.status === 401 &&
        !isRetry &&
        !isRefreshRequest &&
        !isLoginRequest
      ) {
        handleUnauthorized(error);
      } else if (error.response?.status !== 401) {
        handleUnauthorized(error);
      }

      // Do not toast here — callers already show error toasts.
      return Promise.reject(error);
    },
  );
};
